import { env } from './env';

export type WhatsAppClickSource =
  | 'home'
  | 'catalogue'
  | 'deal'
  | 'dashboard'
  | 'contact'
  | 'about'
  | 'faq'
  | 'sell'
  | 'other';

export type TrackWhatsAppClickInput = {
  pageSource: WhatsAppClickSource;
  dealId?: string;
  language?: string;
  sessionId?: string;
};

const SESSION_KEY = 'ddm_session_id';

function getSessionId(): string {
  if (typeof window === 'undefined') return '';
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function trackWhatsAppClick(input: TrackWhatsAppClickInput): void {
  if (!env.supabase.url || !env.supabase.anonKey) return;

  const body = JSON.stringify({
    page_source: input.pageSource,
    deal_id: input.dealId,
    language: input.language ?? 'en',
    session_id: input.sessionId ?? getSessionId(),
  });

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(
      `${env.supabase.url}/functions/v1/whatsapp-tracking?apikey=${env.supabase.anonKey}`,
      blob,
    );
  } else {
    fetch(`${env.supabase.url}/functions/v1/whatsapp-tracking`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: env.supabase.anonKey,
        Authorization: `Bearer ${env.supabase.anonKey}`,
      },
      body,
      keepalive: true,
    }).catch(() => {});
  }
}
